const SkeletonTextItem = ({width}) => {
    return (
        <div className="skeleton-item" style={{width: width+"%"}}>
            <p className="row-text">Hello</p>
        </div>
    );
};

export default SkeletonTextItem;